import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSchoolActivityList, AddSchoolActivity, DeleteSchoolActivity, EditSchoolActivity } from 'api/v1.manager.schoolactivity';
import { importActivity } from 'api/v1.design.PrepareImport';
import NewThumbnail from 'components/AliyunOSS/NewThumbnail.vue';
export default {
  components: {
    'oss-newthumbnail': NewThumbnail
  },
  props: {
    schoolCourseId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    userType: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      importDialogVisible: false,
      word: '',
      // newCourseId: this.$route.params.courseId,

      /** 分页 */
      totalCount: -1,
      loadingShow: false,
      noDataShow: false,
      pageSize: 10,
      pageIndex: 1,

      /** 查询条件 */
      paperType: '3',

      /** 返回列表 */
      list: [],
      addName: '',

      /** */

      /* 颜色改变 */
      active: 1,
      myid: '',
      otherid: '',
      menuShow: false,
      dialogFormVisibleBrainStormOrDiscuss: false,
      activityName: '',
      activityContent: '',
      ActivityRemake: '',
      activityType: 6,
      urlAliyunOSS: '/api/XOrg/AssociationIndex/getSign',
      docJson: '',
      disabled: false,
      dataJson: [{
        name: 'A',
        content: ''
      }, {
        name: 'B',
        content: ''
      }, {
        name: 'C',
        content: ''
      }],
      activityId: '',
      activityRemake: '',
      voteType: '正确错误',
      paperName: '',
      seleteDate: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      ids: []
    };
  },
  created: function created() {
    this.GetSchoolActivityList(1);
  },
  computed: {
    auth: function auth() {
      var auth = this.$store.state.auth;
      return _objectSpread({}, auth);
    }
  },
  methods: {
    ImportActivity: function ImportActivity() {
      var _this = this;

      importActivity(this.ids, this.courseId).then(function (rst) {
        if (rst.code > 0) {
          _this.GetSchoolActivityList(1);

          _this.importDialogVisible = false;

          _this.$message.success(rst.code);
        } else {
          _this.$message.warning(rst.code);
        }
      });
    },
    // 投票选项的删除
    deleteData: function deleteData(index) {
      this.dataJson.splice(index, 1);
      this.sortDateJson();
    },

    /** 返回列表 */
    GetSchoolActivityList: function GetSchoolActivityList(page) {
      var _this2 = this;

      this.loadingShow = true;
      getSchoolActivityList(this.schoolCourseId, this.courseId, 6, this.paperName, page, this.pageSize).then(function (rst) {
        _this2.list = rst.list;
        _this2.loadingShow = false;

        if (_this2.list.length === 0) {
          _this2.noDataShow = true;
        } else {
          _this2.noDataShow = false;
        }

        _this2.totalCount = rst.pagination.totalCount;
        _this2.pageSize = rst.pagination.pageSize;
        _this2.pageIndex = rst.pagination.pageIndex;
      });
    },
    handleClose: function handleClose(done) {
      done();
      this.cancel();
    },
    // 新增弹框
    vote: function vote() {
      this.activityType = 6;
      this.title = '投票';
      this.activityName = this.getNowFormatDate() + '的投票';
      this.dialogFormVisibleBrainStormOrDiscuss = true;
      this.disabled = false;
    },
    // 新增/编辑判断
    addoredit: function addoredit() {
      if (this.activityId === '') {
        this.disabled = true;
        this.AddFaceTeachActivity();
      } else {
        this.disabled = true;
        this.EditFaceTeachActivity();
      } // this.GetSchoolActivityList(this.pageIndex);

    },
    // 添加活动
    AddFaceTeachActivity: function AddFaceTeachActivity() {
      var _this3 = this;

      var dataJson = JSON.stringify(this.dataJson);
      var voteType = 0;

      if (this.activityContent === '') {
        this.activityContent = '暂无内容';
      }

      if (this.voteType === '正确错误') voteType = 1;else if (this.voteType === '赞成反对') voteType = 2;else if (this.voteType === '单选') voteType = 3;else if (this.voteType === '多选') voteType = 4;

      if (this.activityType === 6 && this.activityContent === '') {
        this.$message.warning('投票内容不能为空');
        this.disabled = false;
        return false;
      }

      if (this.activityType === 6 && this.voteType === 0) {
        this.$message.warning('投票类型不能为空');
        this.disabled = false;
        return false;
      }

      if ((this.voteType === 3 || this.voteType === 4) && this.dataJson.length === 0) {
        this.$message.warning('投票选项不能未空');
        this.disabled = false;
      }

      var imageurl = '';

      if (typeof this.docJson === 'string') {
        imageurl = this.docJson;
      } else {
        this.docJson.forEach(function (url) {
          imageurl += url + ';';
        });
      }

      AddSchoolActivity(this.schoolCourseId, this.courseId, this.activityName, this.activityContent, voteType, dataJson, this.activityType, this.ActivityRemake, // this.docJson,
      imageurl, this.questionType = 0, this.userType).then(function (rst) {
        _this3.$message({
          type: 'warning',
          message: rst.msg
        });

        if (rst.code > 0) {
          _this3.activityId = '';

          _this3.cancel();

          _this3.GetSchoolActivityList();
        }

        _this3.disabled = false;
      });
    },
    // 编辑活动
    EditFaceTeachActivity: function EditFaceTeachActivity() {
      var _this4 = this;

      var dataJson = JSON.stringify(this.dataJson);
      var voteType = 0;

      if (this.activityContent === '') {
        this.activityContent = '暂无内容';
      }

      if (this.voteType === '正确错误') voteType = 1;else if (this.voteType === '赞成反对') voteType = 2;else if (this.voteType === '单选') voteType = 3;else if (this.voteType === '多选') voteType = 4;
      var imageurl1 = '';

      if (typeof this.docJson === 'string') {
        imageurl1 = this.docJson;
      } else {
        this.docJson.forEach(function (url) {
          imageurl1 += url + ';';
        });
      }

      EditSchoolActivity(this.activityId, this.activityName, this.activityContent, this.ActivityRemake, this.questionType = 0, voteType, dataJson, // this.docJson
      imageurl1).then(function (rst) {
        _this4.$message({
          type: 'warning',
          message: rst.msg
        });

        if (rst.code > 0) {
          _this4.activityId = '';

          _this4.cancel();
        }

        _this4.disabled = false;
      });
      this.GetSchoolActivityList(this.pageIndex);
    },
    // 打开编辑活动弹窗
    editActivity: function editActivity(row) {
      this.disabled = false;
      this.activityId = row.id;
      this.activityType = 6;
      this.activityName = row.activityName;
      this.activityContent = row.activityContent;
      this.voteType = row.voteType;

      if (row.docJson.indexOf(';') > 0) {
        // this.docJson = row.docJson.split(";");
        var aa = row.docJson.split(';');
        aa.pop();
        this.docJson = aa;
      } else {
        this.docJson = row.docJson;
      }

      this.dataJson = row.dataJson === '' ? this.dataJson : eval('(' + row.dataJson + ')');
      this.activityRemake = row.activityRemake;
      this.dialogFormVisibleBrainStormOrDiscuss = true;
    },
    onPageChangeHandler: function onPageChangeHandler(page) {
      this.GetSchoolActivityList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.GetSchoolActivityList(1);
    },
    // 删除活动
    deleteActivity: function deleteActivity(id) {
      var _this5 = this;

      this.$confirm('此操作将删除当前活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 删除班级
        DeleteSchoolActivity(id).then(function (rst) {
          _this5.$message.warning(rst.msg);

          _this5.GetSchoolActivityList(_this5.pageIndex);
        });
      }).catch(function () {
        _this5.$message.info('已取消删除');
      });
    },
    goto: function goto(name, params) {
      this.$router.push({
        name: name,
        params: params
      });
    },
    changeMenu: function changeMenu() {
      this.menuShow = !this.menuShow;
    },
    // 获取当前时间方法
    getNowFormatDate: function getNowFormatDate() {
      var date = new Date();
      var seperator1 = '-';
      var seperator2 = ':';
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }

      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }

      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + date.getHours() + seperator2 + date.getMinutes() + seperator2 + date.getSeconds();
      return currentdate;
    },
    // 取消弹窗方法
    cancel: function cancel() {
      this.activityId = '';
      this.activityName = '';
      this.activityContent = '';
      this.questionType = 1, this.voteType = '正确错误', this.paperId = '';
      this.dataJson = [{
        name: 'A',
        content: ''
      }, {
        name: 'B',
        content: ''
      }, {
        name: 'C',
        content: ''
      }];
      this.dialogFormVisibleSign = false;
      this.dialogFormVisibleBrainStormOrDiscuss = false;
      this.dialogFormVisibleSignOrQuestion = false;
      this.dialogFormVisiblePaper = false;
      this.docJson = '';
      this.GetSchoolActivityList(this.pageIndex);
    },
    // 投票选项添加
    addData: function addData() {
      this.dataJson.push({
        name: '',
        content: ''
      });
      this.sortDateJson();
    },
    // 渲染选项集
    sortDateJson: function sortDateJson() {
      var _this6 = this;

      this.dataJson.forEach(function (element, index) {
        element.name = _this6.seleteDate[index];
      });
    }
  }
};